import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { logOut } from "../../../redux/action/auth";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getGstVerificationData } from "../../../redux/action/gtsVerification";


function GSTNumber() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 999px)" });

  const { gstLoading, } = useSelector((state) => state?.gstVerification)

  const formik = useFormik({
    initialValues: {
      gstNumber: "",
    },
    validationSchema: Yup.object({
      gstNumber: Yup.string()
        .required("GST number is required")
        .length(15, "GST number must be exactly 15 characters")
    }),
    onSubmit: (values) => {
      dispatch(getGstVerificationData(values?.gstNumber, navigate))

    },
  });



  return (
    <div className="auth-from slide-in" style={{ width: isLaptop && "700px" }}>
      <div className={`flex justify-end full-width`}>

        <button
          className="button-style cercle-purple white-text"
          onClick={() => dispatch(logOut())}
        >
          Logout
        </button>

      </div>

      <div style={{ width:isTablet?"100%": "420px", margin: "auto" }}>
        <h3 className="flex justify-center mb-2">GST Number</h3>
        <p className="font-18px">Enter your gst number</p>

        <form onSubmit={formik.handleSubmit}>
          <div className="input-field-style margin-0px">
            <span className="material-symbols-outlined">apartment</span>
            <input
              className="browser-default"
              placeholder="Enter your gst number"
              type="text"
              name="gstNumber"
              value={formik.values.gstNumber}
              onChange={(event) => {
                const trimmedValue = event.target.value.trim();
                formik.setFieldValue("gstNumber", trimmedValue);
              }}
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.touched.gstNumber && formik.errors.gstNumber ? (
            <p className="formicError">{formik.errors.gstNumber}</p>
          ) : null}




          <div className="flex justify-center mt-3 gap-2">
            <button
              className={`button-style bold cercle-purple white-text pointer`}
              style={{ padding: "10px 35px" }}
              type="submit"
            >
              {gstLoading ? (
                <ClipLoader color="#fff" size={20} />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default GSTNumber;


